// extracted by mini-css-extract-plugin
module.exports = {"columnTableHead":"JamDataTable_columnTableHead__p70NR"};